export default __webpack_public_path__ + "images/assets/fc24d69346b5ac81bce43a4595357226.svg";